export const hideMegaMenu = e => {
  const activeLi = "active-li";
  let parent = e.currentTarget?.parentElement;

  while (parent && !parent.classList.contains(activeLi)) {
    parent = parent.parentElement;
  }

  if (parent?.classList.contains(activeLi)) {
    parent.parentElement.nextElementSibling.classList.remove("active");
  }

  return null;
};

export const highlight = e => {
  const highlighted = "highlighted";
  const tlm = "top-level-menu";
  const highlightedEl = document.querySelector(`.${highlighted}`);
  let parent = e.currentTarget?.parentElement;

  while (parent && !parent.classList.contains(tlm)) {
    parent = parent.parentElement;
  }
  if (parent?.classList.contains(tlm)) {
    highlightedEl && highlightedEl.classList.remove(highlighted);
    parent.querySelector(".arrow").classList.add(highlighted);
  }

  return null;
};

export const getElementHeight = domElement => {
  if (!domElement) return null;
  const { height } = domElement.getBoundingClientRect();
  return height;
};

export const removeScriptFromBody = (script: HTMLScriptElement) => {
  script.parentNode?.removeChild(script);
};

export const addScriptToDocument = (() => {
  let scriptState = {};

  return (
    target: string,
    src: string,
    onLoad: (...args) => void = null,
    preventReAdding?: boolean
  ) => {
    const scriptTags =
      preventReAdding && document.querySelectorAll(`script[src="${src}"]`);

    if (scriptTags?.length) {
      if (scriptState[src]?.loaded) {
        return false;
      } else {
        scriptTags.forEach(removeScriptFromBody);
      }
    }
    if (!scriptState[src]) {
      scriptState[src] = { loaded: false, callbacks: [] };
    }

    scriptState[src].callbacks.push(onLoad);

    const script = document.createElement("script");
    const isDynamicYieldScript = src.includes("dynamicyield.com/api/");
    if (isDynamicYieldScript) {
      script.type = "text/javascript";
    }
    script.src = src;

    script.onload = (...args) => {
      if (scriptState[src]?.loaded) {
        return;
      }
      scriptState[src].callbacks.forEach(callback => {
        callback?.(...args);
      });
      scriptState[src].loaded = true;
    };
    const targetElement = document[target];
    if (isDynamicYieldScript && targetElement) {
      const dyApiScripts = targetElement.querySelectorAll(
        'script[src*="dynamicyield.com/api/"]'
      );
      if (dyApiScripts.length > 0) {
        dyApiScripts[dyApiScripts.length - 1].insertAdjacentElement(
          "afterend",
          script
        );
        return script;
      }

      const dyContext = targetElement.querySelector("#dy-context");
      if (dyContext) {
        dyContext.insertAdjacentElement("afterend", script);
        return script;
      }

      const dyPreconnects = targetElement.querySelectorAll(
        'link[rel="preconnect"][href*="dynamicyield"]'
      );
      if (dyPreconnects.length > 0) {
        dyPreconnects[dyPreconnects.length - 1].insertAdjacentElement(
          "afterend",
          script
        );
        return script;
      }
    }
    targetElement.appendChild(script);
    return script;
  };
})();

export const addScriptToBody = (...args: [string, (() => void)?, boolean?]) => {
  return addScriptToDocument("body", ...args);
};

export const addScriptToHead = (...args: [string, (() => void)?, boolean?]) => {
  return addScriptToDocument("head", ...args);
};

export const scrollParentToChild = (parent, child) => {
  const parentRect = parent.getBoundingClientRect();
  const parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth
  };

  const childRect = child.getBoundingClientRect();
  const isViewable =
    childRect.top >= parentRect.top &&
    childRect.bottom <= parentRect.top + parentViewableArea.height;

  if (!isViewable) {
    const scrollTop = childRect.top - parentRect.top;
    const scrollBot = childRect.bottom - parentRect.bottom;
    if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
      parent.scrollTop += scrollTop;
    } else {
      parent.scrollTop += scrollBot + 20;
    }
  }
};
